// extracted by mini-css-extract-plugin
module.exports = {"btn":"substitution-btn_btn__3Q15U"};